import React from 'react'
import { useGLTF} from '@react-three/drei'
import ParaventoGenerale from './ParaventoGenerale'

export function ParaventoUnico100() {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/models/paravento/unico100/ParaventoUnico100.gltf`)

  return ( 
    <ParaventoGenerale 
          nodeCorpoName={nodes.LayerCorpo.geometry} 
          nodeVetroName={nodes.LayerVETRO.geometry}              
          pos1={[1.27, 1.27, 0.051]}
          rot1={[-Math.PI / 2, 0, 0]}
          pos2={[1.283, 1.283, 0.044]}
          rot2={[-Math.PI / 2, 0, 0]}  
          sc1={0.025}
          sc2={0.025}      
          mainRotation={[0, -Math.PI / 2, 0]}              
        />
  )
}

useGLTF.preload(`${process.env.PUBLIC_URL}/models/paravento/unico100/ParaventoUnico100.gltf`)
